import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a5af39"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "container" }, null, -1))

import { onMounted, onUnmounted, ref, nextTick, reactive } from "vue";
import { debounce, Toast } from "@/utils";
import AMapLoader from "@amap/amap-jsapi-loader";
import {
  getPrototypeRegistrationList,
  getSerialGPSByPrototypeRegistrationId,
} from "@/request/view/prototypeManagement";
import { GPS2GCJ02 } from "./translate";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {

const visible = ref(false);

const handleUpdateLocation = debounce(async () => {
  await getSeriesLocation();
  map.clearMap();
  if (seriesLocation.value === "current") {
    setCurrentLocation();
  }
  if (seriesLocation.value === "history") {
    setHistoryLocation();
  }
}, 10);

// 设备位置
const seriesLocation = ref("current");

// 设备位置
const locationList = reactive([]);

// 获取设备位置
const getSeriesLocation = async () => {
  locationList.length = 0;
  await getSerialGPSByPrototypeRegistrationId({ prototypeRegistrationId: series.value }).then(
    (res) => {
      const { data } = res;
      data.forEach((item: any) => {
        locationList.push({
          localDate: item.localDate,
          location: GPS2GCJ02(item.lon, item.lat),
        });
      });
    }
  );
};

// 设备当前位置
const setCurrentLocation = () => {
  if (locationList.length === 0) return;
  const { location, localDate } = locationList[0];

  const marker = new aMap.Marker({
    position: new aMap.LngLat(...location),
    label: {
      content: localDate,
      direction: "bottom",
    },
  });

  map.add(marker);
  map.setZoomAndCenter(20, new aMap.LngLat(...location), false, 500);
};

// 设置历史位置
const setHistoryLocation = () => {
  if (locationList.length === 0) return;
  const path: any = [];

  for (let index = 0; index < locationList.length; index++) {
    let { location, localDate } = locationList[index];
    const marker = new aMap.Marker({
      position: new aMap.LngLat(...location),
      label: {
        content: localDate,
        direction: "bottom",
      },
    });

    marker.on("click", function (e) {
      const { lng, lat } = e.target._position;
      //同时传入缩放级别和中心点经纬度
      map.setZoomAndCenter(20, new aMap.LngLat(lng, lat), false, 500);
    });
    map.add(marker);
    path.push(new aMap.LngLat(...location));
  }

  //创建 Polyline 实例
  const polyline = new aMap.Polyline({
    path: path,
    strokeWeight: 2, //线条宽度
    strokeColor: "#ff787f", //线条颜色
    lineJoin: "round", //折线拐点连接处样式
    showDir: true,
    geodesic: true,
  });

  map.add(polyline);
  map.setZoomAndCenter(20, new aMap.LngLat(...locationList[0].location), false, 500);
};

// 远程搜索
const seriesData = ref([]);
const series = ref();
let timeout: any;
let currentValue = "";
function fetch(value: string, callback: any) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function fake() {
    getPrototypeRegistrationList({ prototypeSerial: value, pageNum: 1, lineNum: 10 }).then(
      (res) => {
        const result = [];
        res.data.records.forEach((item: any) => {
          result.push({
            label: item.prototypeSerial,
            value: item.id,
          });
        });
        callback(result);
      }
    );
  }

  timeout = setTimeout(fake, 300);
}

const handleSearch = (val: string) => {
  fetch(val, (d: any[]) => (seriesData.value = d));
};
const handleChange = (val: string) => {
  series.value = val;
  map.clearMap();
  handleUpdateLocation();
};

let map: any = null;

let aMap: any = null;

function initMap() {
  AMapLoader.load({
    key: "df6ad46c49b60f167b2e6d77da9b2709", // 申请好的Web端开发者Key，首次调用 load 时必填
    version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: ["AMap.ControlBar", "AMap.HawkEye", "AMap.ToolBar", "AMap.Scale"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
    AMapUI: {
      // 是否加载 AMapUI，缺省不加载
      version: "1.1", // AMapUI 缺省 1.1
      plugins: [], // 需要加载的 AMapUI ui插件
    },
  })
    .then((AMap) => {
      aMap = AMap;
      const scale = new AMap.Scale();
      const toolBar = new AMap.ToolBar({
        position: {
          top: "110px",
          right: "40px",
        },
      });

      const overView = new AMap.HawkEye({
        opened: true,
      });
      map = new AMap.Map("container", {
        // 设置地图容器id
        viewMode: "2D", // 是否为3D地图模式
        zoom: 5, // 初始化地图级别
        center: [108.946609, 34.262324], // 初始化地图中心点位置
        mapStyle: "amap://styles/normal", // 设置地图的显示样式
      });

      map.addControl(scale);
      map.addControl(toolBar);
      map.addControl(overView);

      //绑定radio点击事件
      const radios: Array<HTMLLIElement> = Array.from(
        document.querySelectorAll("#map-styles input")
      );
      radios.forEach(function (ratio) {
        ratio.onclick = setMapStyle;
      });

      function setMapStyle() {
        const styleName = "amap://styles/" + this.value;
        map.setMapStyle(styleName);
      }

      // 创建一个右键菜单实例
      var contextMenu = new AMap.ContextMenu();
      // 缩放范围
      contextMenu.addItem(
        "缩放至全国范围",
        function (e) {
          map.setZoomAndCenter(5, [108.946609, 34.262324]);
        },
        0
      );
      // 缩放至省份范围
      contextMenu.addItem(
        "缩放至省份范围",
        function (e) {
          map.setZoom(7);
        },
        1
      );

      //地图绑定鼠标右击事件——弹出右键菜单
      map.on("rightclick", function (e) {
        contextMenu.open(map, e.lnglat);
      });

      setCurrentLocation();
    })
    .catch((e) => {
      console.log(e);
    });
}

async function showModal(record) {
  series.value = record.id;
  await getSeriesLocation();
  if (locationList.length === 0) {
    Toast('warning', '无定位数据', 3);
    return
  }
  // 初始列表
  seriesData.value.length = 0;
  seriesData.value.push({
    label: record.prototypeSerial,
    value: record.id,
  });
  seriesLocation.value = 'current';
  visible.value = true;
  setTimeout(() => {
    nextTick(() => {
      initMap();
    });
  }, 10);
}

onUnmounted(() => {
  map?.destroy();
});

__expose({ showModal });

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    footer: null,
    width: "100%",
    wrapClassName: "full-modal",
    centered: true
  }, {
    title: _withCtx(() => [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: series.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((series).value = $event)),
            "show-search": "",
            placeholder: "请输入设备机身号",
            style: {"width":"200px"},
            "default-active-first-option": false,
            "show-arrow": false,
            "filter-option": false,
            "not-found-content": null,
            options: seriesData.value,
            allowClear: "",
            onSearch: handleSearch,
            onChange: handleChange
          }, null, 8, ["value", "options"]),
          _createVNode(_component_a_radio_group, {
            value: seriesLocation.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((seriesLocation).value = $event)),
            onClick: _withModifiers(_unref(handleUpdateLocation), ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_button, { value: "current" }, {
                default: _withCtx(() => [
                  _createTextVNode("当前位置")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio_button, {
                value: "history",
                disabled: seriesData.value.length > 1
              }, {
                default: _withCtx(() => [
                  _createTextVNode("历史位置")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["value", "onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})